import Cookies from 'js-cookie';

import { public_urls } from '../config';

const auth = {
  clearCookies() {
    Object.keys(Cookies.get()).forEach(cookieName => {
      Cookies.remove(cookieName);
    });
  },
  async logout() {
    auth.clearCookies();
    sessionStorage.clear();
    window.location.href = public_urls.logout;
  },
};

export default auth;
